import { Controller } from 'stimulus';
import { useDispatch, useHover, useIntersection } from 'stimulus-use';

export default class extends Controller {
  static values = {
    index: Number,
  }

  options = {
    threshold: 0,
  }

  connect() {
    useDispatch(this);
    useIntersection(this, this.options);
    useHover(this);
    this.isManual = false;
  }

  disconnect() {
    this.element.pause();
  }

  mouseEnter(e) {
    this.dispatch('mouseenter');
  }

  mouseLeave(e) {
    this.dispatch('mouseleave');
  }

  mute(e) {
    this.element.setAttribute('muted', '');
    this.element.muted = true;
  }

  demute(e) {
    this.element.removeAttribute('muted');
    this.element.muted = false;
  }


  async appear(entry) {
    try {
      if (!this.isManual){
        this.element.removeAttribute('controls');
      this.dispatch('hidecontrols');
      }
      await this.element.play();
    } catch (err) {
      this.dispatch('showcontrols');
      this.isManual = true;
    }
  }

  disappear(entry) {
    this.element.pause();
  }
}
